"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
const calculateFiscalYear = (currentYear) => {
    const currentYearInterval = luxon_1.Interval.fromISO(currentYear);
    return (currentYear.match(/^\d{4}\/\d{4}$/)
        ? currentYearInterval.set({
            start: currentYearInterval.start.set({
                month: 7,
                day: 1,
                hour: 0,
                minute: 0,
                second: 0,
            }),
            end: currentYearInterval.end.set({
                month: 6,
                day: 30,
                hour: 23,
                minute: 59,
                second: 59,
            }),
        })
        : currentYearInterval).toFormat("LL/yy");
};
exports.default = calculateFiscalYear;
